<template>
  <div class="page story">
    <div class="icon icon-circle1 abs"></div>
    <div class="icon icon-circle2 abs" v-if="step !== 3"></div>
    <div class="icon icon-mg-logo abs"></div>
    <div class="page-main">
      <one-step v-if="step === 1" @next="onClickJoin" />
      <two-step v-else-if="step === 2" @next="onClickAgree" />
      <three-step v-else-if="step === 3" @next="onSubmitForm" @toast="onShowToast" />
      <four-step v-else-if="step === 4" @share="onClickShare" />
    </div>
    <transition-group name="list" tag="p">
      <p
        v-for="(item, index) in toasts"
        :style="{ transform: `translate(-50%,-${(index % 4) * 105}%)` }"
        :key="item.id"
        class="list-item"
      >
        {{ item.content }}
      </p>
    </transition-group>
  </div>
</template>

<script>
import * as Apis from "@/apis";
import Env from "@/utils/env";
import LoginSDK from "@/utils/login";
import OneStep from "./step/One.vue";
import TwoStep from "./step/Two.vue";
import FourStep from "./step/Four.vue";
import ThreeStep from "./step/Three.vue";

export default {
  components: {
    OneStep,
    FourStep,
    TwoStep,
    ThreeStep
  },
  data() {
    return {
      step: 1,
      toasts: [],
    };
  },
  methods: {
    onClickShare() {
      this.$emit("share");
    },
    createRemoveToastTask(target, duration = 2000) {
      setTimeout(() => {
        this.toasts = this.toasts.filter(item => item !== target);
      }, duration);
    },
    removeToast(id) {
      this.toasts = this.toasts.filter(item => item.id !== id);
    },
    onShowToast(content, removeId) {
      if (removeId) {
        this.removeToast(removeId);
      }
      if (content) {
        const id = Date.now() + Math.floor(Math.random() * 10000);
        const item = { id, content };
        const isMax = this.toasts.length === 3;
        if (isMax) {
          this.toasts.shift();
        }
        this.toasts.push(item);
        this.createRemoveToastTask(item);
        return id;
      }
      return null;
    },
    async onClickJoin() {
      if(this.isDev) {
        this.step = 2
        return
      }
      const { uuid } = this.dataStore.getInfo();
      if (!uuid) {
        LoginSDK.login();
        return;
      }
      try {
        try {
          const existInfo = await Apis.getInfo({ uuid });
          console.log(existInfo);
          this.step = 4;
        } catch (error) {
          if (error.code === 1008) {
            this.step = 2;
          }
        }
      } catch (error) {}
    },
    onClickAgree() {
      this.step = 3;
    },
    onSubmitForm() {
      this.step = 4;
    },
  }
};
</script>


<style lang="scss">
@import "~@/assets/mixins.scss";

.story {
  * {
    user-select: none;
  }
  input , textarea {
    user-select: auto;
  }
  .page-main {
    position: relative;
  }
  .icon-mg-logo {
    @include px2vw(top, 20);
    @include px2vw(left, 30);
  }
}
.list-item {
  display: block;
  position: fixed;
  bottom: 10%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  color: white;
  background: rgba(0, 0, 0, 0.7);
  padding: 0.5em 1em;
  border-radius: 1em;
  opacity: 1;
  font-size: 14px;
  max-width: 95vw;
  width: max-content;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  box-sizing: content-box;
}
.list-enter-active,
.list-leave-active {
  transition: all 0.5s;
}
.list-enter, .list-leave-to
/* .list-leave-active for below version 2.1.8 */ {
  opacity: 0;
}
</style>
